<template>
  <el-row class="register-protocol-container">
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header" class="clearfix flex justify-between">
          <span>注册协议</span>
        </div>
        <el-form label-position="right" label-width="120px">
          <el-form-item :label="$t('registerProtocol.userProtocol')">
            <div class="editor-container">
              <quill-editor 
                v-model="registerProtocolInfo.userProtocol"
                :options="editorOption"
                @change="onEditorChange($event, 'userProtocol')"
              />
            </div>
          </el-form-item>
          
          <el-form-item :label="$t('registerProtocol.merchantProtocol')">
            <div class="editor-container">
              <quill-editor 
                v-model="registerProtocolInfo.merchantProtocol"
                :options="editorOption"
                @change="onEditorChange($event, 'merchantProtocol')"
              />
            </div>
          </el-form-item>

          <el-form-item>
            <el-button 
              type="primary" 
              class="float-right"
              @click="updateRegisterProtocol"
            >
              {{ $t('common.modify') }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getRegisterProtocolList, updateRegisterProtocol } from '@/api/frame/registerProtocol/registerProtocolApi'
//import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'RegisterProtocol',
  components: {
   // quillEditor
  },
  data() {
    return {
      registerProtocolInfo: {
        userProtocol: '',
        merchantProtocol: '',
        protolcolId: ''
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
          ]
        },
        placeholder: this.$t('registerProtocol.required'),
        theme: 'snow'
      }
    }
  },
  created() {
    this.getRegisterProtocols()
  },
  methods: {
    onEditorChange({ html }, field) {
      this.registerProtocolInfo[field] = html
    },
    async getRegisterProtocols() {
      try {
        const res = await getRegisterProtocolList({ page: 1, row: 1 })
        if (res.data && res.data.length > 0) {
          this.registerProtocolInfo = { ...res.data[0] }
        }
      } catch (error) {
        console.error('获取注册协议失败:', error)
      }
    },
    async updateRegisterProtocol() {
      try {
        const res = await updateRegisterProtocol(this.registerProtocolInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.modifySuccess'))
          this.getRegisterProtocols()
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('更新注册协议失败:', error)
        this.$message.error(this.$t('common.modifyFailed'))
      }
    }
  }
}
</script>

<style scoped>
.register-protocol-container {
  width: 100%;
}
.editor-container {
  margin-bottom: 20px;
}
.float-right {
  float: right;
}
</style>